import { useState } from "react";

const PDF_EXTENSION = ".pdf";

export interface UploadFormatDialogState {
  files: File[] | null;
  onConfirm: (convertToPdf: boolean) => void;
  onCancel: () => void;
}

export function useUploadFormatPrompt(upload: (file: File, convertToPdf: boolean) => void) {
  const [pendingFiles, setPendingFiles] = useState<File[] | null>(null);

  const promptOrUpload = (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) {
      return;
    }
    if (acceptedFiles.every((file) => file.name.toLowerCase().endsWith(PDF_EXTENSION))) {
      acceptedFiles.forEach((file) => upload(file, false)); // pure-PDF batch — skip the dialog
    } else {
      setPendingFiles(acceptedFiles); // contains a non-PDF — ask via the dialog
    }
  };

  const formatDialog: UploadFormatDialogState = {
    files: pendingFiles,
    onConfirm: (convertToPdf) => {
      pendingFiles?.forEach((file) => upload(file, convertToPdf));
      setPendingFiles(null);
    },
    onCancel: () => setPendingFiles(null),
  };

  return { promptOrUpload, formatDialog };
}
